import React from "react";
import TrainerCardIcons from "./TrainerCardIcons";
import "./TrainerCardOverlay.scss";

const TrainerCardOverlay = () => (
  <div className="cardOverlay">
    <TrainerCardIcons />
  </div>
);

export default TrainerCardOverlay;
